import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=7597b71d&scoped=true"
import script from "./ChangeStatus.vue?vue&type=script&lang=js"
export * from "./ChangeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7597b71d",
  null
  
)

export default component.exports